import React from "react"
import classnames from 'classnames';
import { useStaticQuery, graphql } from "gatsby"
import Img from "gatsby-image"
import { Button } from 'semantic-ui-react'
import Layout from "../components/layout"
import SEO from "../components/seo"
import Hero from '../components/hero'

import styles from '../styles/pages/index.module.scss'

const IndexPage = () => {
  const data = useStaticQuery(graphql`
    query {
      placeholderImage: file(relativePath: { eq: "hero1.webp" }) {
        childImageSharp {
          fluid(maxWidth: 1920) {
            ...GatsbyImageSharpFluid
          }
        }
      },
      placeholderImage2: file(relativePath: { eq: "hero2.webp" }) {
        childImageSharp {
          fluid(maxWidth: 1920) {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
  `)

  const getInfo = () => {
    if (window) {
      window.location = 'https://wa.link/ypmk5h';
    }
  }

  return (
    <Layout>
      <SEO title="Home" />
      <div className={styles.wrapper}>
        <h1>Brave Nutrition</h1>
        <h2>Especialistas en Dieta Keto</h2>
        <p>Bienvenido! Si estás aquí te felicitamos porque eso significa que eres una persona valiente que está buscando empezar a cuidar de lo más valioso que tienes: tu Salud.</p>
        <p>En Brave Nutrition, nuestro objetivo es generar conciencia de los malos hábitos de salud y alimenticios que probablemente te han hecho sentir estancado o con malestares y alteraciones en todos los niveles, los cuales te impiden disfrutar de tu vida, para cambiarlos por nuevos hábitos que te funcionen, siguiendo una serie de protocolos ya probados que te lleven a mejorar tu calidad de vida a un nivel físico, mental y emocional.</p>
        <p>Queremos que no solo te veas, sino que te sientas espectacular a través de un proceso en el que estamos para guiarte y acompañarte en un nuevo enfoque de bienestar integral.</p>
        <Button primary className="bn-button--secondary" onClick={getInfo}>Quiero comenzar ahora</Button>
      </div>
      <Hero className={styles.hero1} images={[<Img fluid={data.placeholderImage.childImageSharp.fluid} />]} />
      <div className={classnames(styles.wrapper, styles.wrapper1)}>
        <h2>Sobre Brave Nutrition</h2>
        <p>Somos un grupo de promotores de nutrición, salud e imagen, enfocados en brindarte soluciones de bienestar y de esta forma mejores no solo tu físico, sino tu salud en general desde un enfoque integral.</p>
        <p>Manejamos protocolos especializados,  de acuerdo a los requerimientos específicos de cada persona, ya que sabemos que cada cuerpo es diferente y especial, por lo que nos enfocamos en brindar una asesoría totalmente personalizada que te lleve a tu meta de forma sencilla y práctica.</p>
      </div>
      <Hero className={styles.hero1} images={[<Img fluid={data.placeholderImage2.childImageSharp.fluid} />]} />
      <div className={classnames(styles.wrapper, styles.wrapper1, styles.info)}>
        <p><b>Brave Nutrition®</b> Todos los derechos reservados. El Programa Brave Nutrition no sustituye la opinión de tu médico. Este servicio no pretende diagnosticar, curar o prevenir ninguna enfermedad. El material y asesorías que proveemos son con fines informativos únicamente y no sustituye el consejo de un médico o cualquier profesional médico. No recomendamos usar la información compartida por Brave Nutrition para recetar medicamentos o suplementos. El Programa Brave Nutrition es responsabilidad del usuario.</p>
      </div>
    </Layout>
  )
}

export default IndexPage
